import type { ReactNode } from "react";
import { Spinner } from "../atoms/Spinner.tsx";
import { Button } from "../atoms/Button.tsx";

export function LoadingState() {
  return (
    <div className="center-state">
      <Spinner />
      <span>Loading…</span>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="center-state">
      <p style={{ color: "var(--danger)", fontWeight: 600 }}>{message}</p>
      {onRetry && <Button onClick={onRetry}>Try again</Button>}
    </div>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <div className="empty-state">
      <p className="marker">{children}</p>
    </div>
  );
}
